import { render, staticRenderFns } from "./EditMailPropsTemplateDialog.vue?vue&type=template&id=e2994c46"
import script from "./EditMailPropsTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EditMailPropsTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports